/**
 * Checks if the provided version is similar to 0.0
 * @param version
 */
export const isZeroVersion = (version: string | null) => {
  return !version || version === '0.0'
}
